/* eslint-disable import/no-unresolved */
import { Route, Switch } from 'react-router-dom';

import Login from 'views/Auth/Login/components';
import Dashboard from 'views/Dashboard';
import DataConfiguration from 'views/DataRecon/DataConfiguration/containers';
import ReconciliationStatus from 'views/DataRecon/DataConfiguration/containers/ReconciliationStatus';
import DataLineageUpload from 'views/DataRecon/DataLineageUpload/DataLineageUpload';
import Projects from 'views/DataRecon/Projects/containers';
import ReconResultContainer from 'views/DataRecon/ReconResult/containers/ReconResultContainer';
import LandingPage from 'views/LandingPage';
import Remediation from 'views/Remediation';
import ReportDashboard from 'views/ReportDashboard';
import FFIEC009LandingPage from 'views/Rules/FFIEC009/containers/FFIEC009LandingPage';
import FFIEC009ResultsContainer from 'views/Rules/FFIEC009/containers/FFIEC009ResultsContainer';
import FR2052ALandingPage from 'views/Rules/FR2052A/containers/FR2052ALandingPage';
import FR2052AResultsContainer from 'views/Rules/FR2052A/containers/FR2052AResultsContainer';
import FRY7QLandingPage from 'views/Rules/FRY7Q/containers/FRY7QLandingPage';
import FRY7QResultsContainer from 'views/Rules/FRY7Q/containers/FRY7QResultsContainer';
import FRY9CLandingPage from 'views/Rules/FRY9C/containers/FRY9CLandingPage';
import FRY9CResultsContainer from 'views/Rules/FRY9C/containers/FRY9CResultsContainer';
import FFIEC031LandingPage from 'views/Rules/FFIEC031/containers/FFIEC031LandingPage';
import FFIEC031ResultsContainer from 'views/Rules/FFIEC031/containers/FFIEC031ResultsContainer';
import FFIEC041LandingPage from 'views/Rules/FFIEC041/containers/FFIEC041LandingPage';
import FFIEC041ResultsContainer from 'views/Rules/FFIEC041/containers/FFIEC041ResultsContainer';
import Metro2LandingPage from 'views/Rules/Metro2/containers/Metro2LandingPage';
import Metro2ResultsContainer from 'views/Rules/Metro2/containers/Metro2ResultsContainer';
import CreateTenantContainer from 'views/TenantManagement/containers/CreateTenantContainer';
import EditTenantContainer from 'views/TenantManagement/containers/EditTenantContainer';
import TenantContainer from 'views/TenantManagement/containers/TenantContainer';
import UploadReport from 'views/UploadReport';
import PrivacyPolicy from 'views/Terms-Privacy/components/PrivacyPolicy';
import TermsOfUse from 'views/Terms-Privacy/components/TermsOfUse';
import CreateOrEditUserContainer from 'views/UserManagement/containers/CreateOrEditUserContainer';
import UserContainer from 'views/UserManagement/containers/UserContainer';
import SignupContainer from 'views/Auth/Signup/containers/SignupContainer';
import SignupSuccessContainer from 'views/Auth/Signup/containers/SignupSuccessContainer';
import SelfSignupContainer from 'views/Auth/Signup/containers/SelfSignupContainer';
import DataRelationshipContainer from 'views/DataRecon/DataRelationship/containers';
import DataQualityContainer from 'views/DataRecon/DataQuality/containers';
import QualityDetailsContainer from 'views/DataRecon/DataQuality/containers/QualityDetailsContainer';
import ProfilePageContainer from 'views/UserProfile/containers/ProfilePageContainer';
import HomeContainer from 'views/DataRecon/HomePage/containers/HomeContainer';
import CrossReportValidationContainer from 'views/CrossReportValidation/containers';
import TrendAnalyticsContainer from 'views/TrendAnalytics/containers';
import OAuthComponent from 'views/Auth/Login/components/OAuthComponent';
import IntakeContainer from 'views/IntakeRegManagement/containers/IntakeContainer';
import ProtectedRoute from './ProtectedRoute';
import RoleRoute from './RoleRoute';
import ProtectedModuleRoute from './ProtectedModuleRoute';

const Routes = () => (
    <Switch>
        <Route path="/register"><SignupContainer /></Route>
        <Route path="/register-success"><SignupSuccessContainer /></Route>
        <Route path="/login"><Login /></Route>
        <Route path="/registration-intake"><SelfSignupContainer /></Route>
        <Route path="/terms-of-use"><TermsOfUse /></Route>
        <Route path="/privacy-policy"><PrivacyPolicy /></Route>
        <Route path="/callback"><OAuthComponent /></Route>
        <ProtectedRoute path="/demo"><ReportDashboard dataSource="DEMO" /></ProtectedRoute>
        <ProtectedRoute path="/benchmark2"><ReportDashboard dataSource="BENCHMARK" /></ProtectedRoute>
        <ProtectedRoute path="/" exact component={LandingPage} />
        <ProtectedRoute path="/my-profile" exact component={ProfilePageContainer} />
        <ProtectedRoute path="/Dashboard" exact component={Dashboard} />
        <ProtectedModuleRoute path="/fry7q" exact component={FRY7QLandingPage} />
        <ProtectedModuleRoute path="/fry9c" exact component={FRY9CLandingPage} />
        <ProtectedModuleRoute path="/fry9cresults" exact component={FRY9CResultsContainer} />
        <ProtectedModuleRoute path="/ffiec031" exact component={FFIEC031LandingPage} />
        <ProtectedModuleRoute path="/ffiec031results" exact component={FFIEC031ResultsContainer} />
        <ProtectedModuleRoute path="/ffiec041" exact component={FFIEC041LandingPage} />
        <ProtectedModuleRoute path="/ffiec041results" exact component={FFIEC041ResultsContainer} />
        <ProtectedModuleRoute path="/metro2" exact component={Metro2LandingPage} />
        <ProtectedModuleRoute path="/FFIEC009" exact component={FFIEC009LandingPage} />
        <ProtectedModuleRoute path="/fr2052a" exact component={FR2052ALandingPage} />
        <ProtectedModuleRoute path="/metro2Result" exact component={Metro2ResultsContainer} />
        <ProtectedModuleRoute path="/FFIEC009Result" exact component={FFIEC009ResultsContainer} />
        <ProtectedModuleRoute path="/fr2052aResult" exact component={FR2052AResultsContainer} />
        <ProtectedModuleRoute path="/Remediation" exact component={Remediation} />
        <ProtectedModuleRoute path="/UploadReport" exact component={UploadReport} />
        <ProtectedModuleRoute path="/fyresults" exact component={FRY7QResultsContainer} />
        <ProtectedModuleRoute path="/dataconfiguration" exact component={DataConfiguration} />
        <ProtectedModuleRoute path="/projects" exact component={Projects} />
        <ProtectedModuleRoute path="/data-lineage-upload" exact component={DataLineageUpload} />
        <ProtectedModuleRoute path="/datareconciliationstatus" exact component={ReconciliationStatus} />
        <ProtectedModuleRoute path="/datareconresult" exact component={ReconResultContainer} />
        <ProtectedModuleRoute path="/relations" exact component={DataRelationshipContainer} />
        <ProtectedModuleRoute path="/data-quality" exact component={DataQualityContainer} />
        <ProtectedModuleRoute path="/quality-details" exact component={QualityDetailsContainer} />
        <ProtectedModuleRoute path="/data-recon-home" exact component={HomeContainer} />
        <ProtectedModuleRoute path="/cross-report" exact component={CrossReportValidationContainer} />
        {/* <ProtectedModuleRoute path="/analytics" exact component={TrendAnalyticsContainer} /> */}
        <RoleRoute path="/user-management" exact component={UserContainer} />
        <RoleRoute path="/user" exact component={CreateOrEditUserContainer} />
        <RoleRoute path="/tenant-management" exact component={TenantContainer} />
        <RoleRoute path="/create-tenant" exact component={CreateTenantContainer} />
        <RoleRoute path="/edit-tenant" exact component={EditTenantContainer} />
        <RoleRoute path="/interest-intake" exact component={IntakeContainer} />
    </Switch>
);

export default Routes;
